import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { EndpointOIDCUsers } from '#api';
import { makeMaxResourceQueryFn } from '#util/api.ts';
import { endpointOidcUserQueryKeys } from './query-keys.ts';

export const maxEndppointOIDCUsersQueryOptions = queryOptions({
  queryKey: endpointOidcUserQueryKeys.maxList,
  queryFn: makeMaxResourceQueryFn(EndpointOIDCUsers.getEndpointOIDCUsers),
});

export function useSuspenseMaxEndpointOIDCUsersQuery() {
  return useSuspenseQuery(maxEndppointOIDCUsersQueryOptions);
}

// TODO: ideally we'd have an endpoint we could hit to get individual endpoint oidc user info,
// but instead we have to get the whole list and then filter it by id.
export function useConditionalEndpointOIDCUsersQuery(id: string | null, { enabled }: { enabled?: boolean } = {}) {
  // We use the max users query, which is hopefully already cached, and filter to the user in a `select` function.
  return useQuery({
    ...maxEndppointOIDCUsersQueryOptions,
    // If id is falsey and enabled isn't provided, disable the query
    enabled: enabled ?? Boolean(id),
    throwOnError: true,
    select(data) {
      const { data: users } = data;

      return users.find((u) => u.id === id);
    },
  });
}
